class CartNotification extends HTMLElement {
  constructor() {
    super();

    this.notification = document.getElementById('cart-notification');
    this.onBodyClick = this.handleBodyClick.bind(this);

    this.notification.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelectorAll('button[type="button"]').forEach((closeButton) =>
      closeButton.addEventListener('click', this.close.bind(this))
    );

    this.addEventListener('click', (event) => {
      const viewCart = event.target.closest('#cart-notification-button');
      if (!viewCart) return;
      event.preventDefault();
      this.close();
      document.querySelector('cart-drawer')?.open(viewCart);
    });
  }

  open() {
    this.notification.classList.add('animate', 'active');
    document.body.addEventListener('click', this.onBodyClick);
  }

  close() {
    this.notification.classList.remove('active');
    document.body.removeEventListener('click', this.onBodyClick);
    removeTrapFocus(this.activeElement);
  }

  renderContents(parsedState) {
    this.cartItemKey = parsedState.key;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement =
        section.id === 'cart-drawer'
          ? document.querySelector('#CartDrawer')
          : document.getElementById(section.id);
      if (!sectionElement || !parsedState.sections?.[section.id]) return;

      const html = this.getSectionInnerHTML(
        parsedState.sections[section.id],
        section.selector || '.shopify-section'
      );
      if (html == null) return;
      sectionElement.innerHTML = html;
    });

    const drawer = document.querySelector('cart-drawer');
    if (drawer && parsedState.sections?.['cart-drawer']) {
      drawer.classList.toggle('is-empty', parsedState.item_count === 0);
      drawer.bindDrawerInteractions?.();
      drawer.syncBrigidHeaderCount?.(parsedState);
    } else {
      document.querySelector('cart-drawer')?.syncBrigidHeaderCount?.(parsedState);
    }

    this.open();
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-notification-product',
        selector: `[id="cart-notification-product-${this.cartItemKey}"]`,
      },
      {
        id: 'cart-notification-totals',
      },
      {
        id: 'cart-notification-button',
      },
      {
        id: 'cart-icon-bubble',
      },
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    if (!html) return null;
    const parsed = new DOMParser().parseFromString(html, 'text/html');
    const el = parsed.querySelector(selector);
    return el ? el.innerHTML : null;
  }

  handleBodyClick(evt) {
    const target = evt.target;
    if (target !== this.notification && !target.closest('cart-notification')) {
      this.close();
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-notification', CartNotification);
